"use client";

// 루트 에러 바운더리 — 루트 레이아웃 자체가 실패할 때만(자체 html/body 필요).
export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <html lang="ko">
      <body style={{ fontFamily: "system-ui, sans-serif", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", margin: 0, background: "#fafafa", color: "#171717" }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: 32 }}>⚠️</div>
          <h1 style={{ fontSize: 18, fontWeight: 600, margin: "12px 0 4px" }}>시스템 오류</h1>
          <p style={{ fontSize: 14, color: "#737373", margin: 0 }}>
            애플리케이션을 불러오지 못했습니다.{error.digest ? ` (${error.digest})` : ""}
          </p>
          <button onClick={reset} style={{ marginTop: 16, padding: "6px 14px", borderRadius: 6, border: "none", background: "#171717", color: "#fff", fontSize: 13, cursor: "pointer" }}>
            다시 시도
          </button>
        </div>
      </body>
    </html>
  );
}
